import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {filter, map, switchMap} from 'rxjs/operators';
import * as userPaymentMethodsActions from "../actions/user-payment-methods.action";
import {DbResponse} from "../../shared/interceptors/db-response";
import {WorkspaceService} from "../../workspace/workspace.service";

@Injectable()
export class UserPaymentMethodsEffect {


  loadUserPaymentMethods$ = createEffect(() => this._actions$.pipe(
    ofType(userPaymentMethodsActions.LOAD_USER_PAYMENT_METHODS),
    switchMap(() => {
      return this._workspaceService.getPaymentMethods(true)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new userPaymentMethodsActions.LoadUserPaymentMethodsSuccess(response.data);
            } else {
              return new userPaymentMethodsActions.LoadUserPaymentMethodsFail(response.message);
            }
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _workspaceService: WorkspaceService,
  ) {
  }

}
